export default function FaqsHeaderSection({ searchQuery, setSearchQuery }) {
  return (
    <section className="bg-white-warm w-full py-24 px-6 flex flex-col items-center text-center relative overflow-hidden">

      {/* Vertical grid lines */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(1,46,114,0.04) 0px, rgba(1,46,114,0.04) 1px, transparent 1px, transparent 80px)",
        }}
      />

      {/* Top horizontal rule accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-blue-dark opacity-10" />

      {/* Badge */}
      <div className="relative mb-7">
        <span
          className="inline-flex items-center gap-2 border border-blue-dark font-constantia tracking-widest uppercase text-blue-dark px-5 py-1.5 rounded-full"
          style={{ fontSize: "10px", letterSpacing: "0.2em" }}
        >
          <span className="w-1 h-1 rounded-full bg-blue-dark opacity-60 inline-block" />
          Help Center
        </span>
      </div>

      {/* Heading */}
      <h1
        className="font-cinzel font-bold text-blue-dark uppercase relative"
        style={{
          fontSize: "clamp(26px, 5vw, 50px)",
          letterSpacing: "0.06em",
          lineHeight: "1.08",
          maxWidth: "800px",
        }}
      >
        Frequently Asked
        <br />
        Questions
      </h1>

      {/* Decorative rule */}
      <div className="flex items-center gap-3 mt-6 mb-5">
        <div className="h-px w-16 bg-blue-dark opacity-15" />
        <div className="flex gap-1">
          <div className="w-1 h-1 rounded-full bg-blue-dark opacity-30" />
          <div className="w-1 h-1 rounded-full bg-blue-dark opacity-50" />
          <div className="w-1 h-1 rounded-full bg-blue-dark opacity-30" />
        </div>
        <div className="h-px w-16 bg-blue-dark opacity-15" />
      </div>

      {/* Subtext */}
      <p
        className="font-constantia text-black-deep opacity-60 max-w-md leading-relaxed relative"
        style={{ fontSize: "clamp(14px, 1.8vw, 16px)" }}
      >
        Got questions? We've got answers. Browse common questions our clients
        ask before working with us.
      </p>

      {/* Search bar */}
      <div className="relative mt-10 w-full max-w-2xl">
        <svg
          className="absolute left-5 top-1/2 -translate-y-1/2 text-blue-dark opacity-35 pointer-events-none"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>

        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search questions, e.g. claims, consultation, office hours…"
          className="w-full bg-white-pure border border-blue-dark border-opacity-15 rounded-full py-4 pl-12 pr-12 font-constantia text-black-deep placeholder-black-deep placeholder-opacity-25 shadow-sm outline-none focus:border-opacity-40 transition-all duration-200"
          style={{ fontSize: "14.5px" }}
        />

        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-5 top-1/2 -translate-y-1/2 text-blue-dark opacity-35 hover:opacity-60 transition-opacity"
            aria-label="Clear search"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>

      {/* Search result hint */}
      {searchQuery && (
        <p className="font-constantia text-blue-dark opacity-40 mt-3" style={{ fontSize: "12px" }}>
          Showing results for "{searchQuery}"
        </p>
      )}

      {/* Category pills */}
      <div className="flex flex-wrap justify-center gap-2 mt-6 relative">
        {[
          { label: "About Paladin", value: "about paladin" },
          { label: "Consultations", value: "consultation" },
          { label: "Working With Us", value: "working" },
          { label: "Contact & Office", value: "contact" },
        ].map(({ label, value }) => (
          <button
            key={label}
            onClick={() => setSearchQuery(searchQuery === value ? "" : value)}
            className={`font-constantia border px-4 py-1.5 rounded-full transition-all duration-200 ${
              searchQuery === value
                ? "bg-blue-dark text-white-pure border-blue-dark"
                : "text-blue-dark border-blue-dark border-opacity-20 bg-white-pure bg-opacity-70 hover:border-opacity-40 hover:bg-opacity-100"
            }`}
            style={{ fontSize: "12px", letterSpacing: "0.02em" }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Bottom rule */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-blue-dark opacity-8" />
    </section>
  );
}